import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  getGlobalPageLoadData,
  getCombinePricing,
} from "app/ducks/GlobalSlice";

const useGlobalData = ({ isOneTalk, skipSessionCart, clear4g5g = false,gridwall=false } = {}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["app"]);
  const globalData = useSelector((state) => state.GlobalData);
  const isSelectNewGlobalpromos = t("selectNewGlobalpromos", {ns:"app"});
  const allGlobalPromos = isSelectNewGlobalpromos ? !!(globalData?.metaInformation?.newGlobalPromos?.globalPromos) ? globalData?.metaInformation?.newGlobalPromos?.globalPromos :
  globalData?.metaInformation?.globalPromos : globalData?.metaInformation?.globalPromos ;
  const combinePricing = globalData?.combinePricing;
  const editPackagePackageId = globalData?.editPackagePackageId;
  const editPackageGrpId = globalData?.editPackageGrpId;
  const isEditPackageFlow = globalData?.isEditPackageFlow;
  const isEmptyByodFromDQFlow = globalData?.isEmptyByodFromDQFlow;
  const isOrderQuoteFlow = globalData?.isOrderQuoteFlow;
  const isLoading = globalData?.loading;
  const modals = globalData?.modals;
  const metaInformation = globalData?.metaInformation;
  const sessionCartData = globalData?.sessionCartData;
  const cmp = globalData?.cmp;
  const isEditPlansFlow = globalData?.isEditPlansFlow
  useEffect(() => {
    // As part of api optimization ---> calling metainformation after deviceList
    dispatch(getGlobalPageLoadData({
      sessionCart: gridwall ? false : !(clear4g5g || skipSessionCart),
      metaInformation: gridwall ? false : !metaInformation,
      clear4g5gcart: clear4g5g,
      allGlobalPromos: allGlobalPromos,
    }));
    if (isOneTalk) {
      dispatch(getCombinePricing());
    }
  }, []);

  return {
    combinePricing,
    editPackagePackageId,
    editPackageGrpId,
    isEditPackageFlow,
    isEmptyByodFromDQFlow,
    isOrderQuoteFlow,
    isLoading,
    metaInformation,
    modals,
    sessionCartData,
    cmp,
    isEditPlansFlow,
    allGlobalPromos
  };
};

export default useGlobalData;
